export default __webpack_public_path__ + "assets/webgl/picking-26.f496fa63.glb";